export default "szukaj";
